import {createAction} from '@reduxjs/toolkit';
import {
  AllowedLocale,
  LocaleActionTypes,
} from '../localeActionTypes';

export const setLocale = createAction(LocaleActionTypes.SET_LOCALE, (locale: AllowedLocale) => {
  return {payload: locale};
});
